import { Injectable } from '@angular/core';
import { createSelector, select, Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';

import { CoreOriginalSliceState, CoreSliceKey } from './app.state';
import { featureSelector, IAppRootState } from './feature.store';

const baseSelector = createSelector(
	featureSelector,
	(state) => state[CoreSliceKey]
);

@Injectable()
export class AppSelector {
	public constructor(private readonly store: Store<IAppRootState>) {}

	private get state(): Observable<CoreOriginalSliceState> {
		return this.store.pipe(select(baseSelector));
	}

	public getCurrentUserId$(): Observable<string> {
		return this.state.pipe(map((state) => state.get('currentUserId')));
	}
}
